/**
 * Le righe che Portman scrive nei log di un'operazione. Si salvano con
 * l'operazione, quindi restano nella lingua dell'istanza di quel momento.
 */
export const log = {
  // Attesa della salute
  "log.nonIspezionabile": "non ispezionabile",
  "log.reteRitenta": (p: { container: string; dettaglio: string }) =>
    `${p.container}: collegamento alla rete non riuscito (${p.dettaglio}); riprovo…`,
  "log.avvioInCorso": "avvio in corso",
  "log.nonAncoraPresente": "non ancora presente",
  "log.pronto": (p: { container: string }) => `${p.container}: pronto.`,
  "log.healthcheckDice": (p: { stato: string }) => `il suo healthcheck dice "${p.stato}"`,
  "log.containerE": (p: { stato: string }) => `il container è "${p.stato}"`,
  "log.portaChiusa": (p: { porta: number }) => `è in esecuzione ma la porta ${p.porta} non accetta connessioni`,
  "log.portaIrraggiungibile": (p: { porta: number }) =>
    `è in esecuzione ma la porta ${p.porta} non è raggiungibile da qui`,
  "log.porteDichiarate": (p: { porte: readonly number[] }) =>
    ` — dichiara invece ${p.porte.length === 1 ? "la porta" : "le porte"} ${p.porte.join(", ")}`,
  "log.sondaMuta": (p: { container: string; porta: number }) =>
    `${p.container}: nessun healthcheck, e non riesco a raggiungere la porta ${p.porta} per verificarlo. ` +
    "Mi accontento che il processo sia in esecuzione: il traffico si sposta appena parte.",
  "log.portaAperta": (p: { container: string; porta: number }) =>
    `${p.container}: nessun healthcheck; la porta ${p.porta} accetta connessioni.`,
  "log.attesa": (p: { container: string; motivo: string; secondi: number }) =>
    `${p.container}: ${p.motivo}; attendo da ${p.secondi} s.`,

  // Rilascio blue/green
  "log.preparazione": (p: { generazione: string }) =>
    `Preparazione della generazione "${p.generazione}" accanto a quella in esecuzione…`,
  "log.avvioFissi": (p: { progetto: string }) => `Avvio dei servizi fissi sul progetto "${p.progetto}"…`,
  "log.ricollegaFissi": "Ricollegamento dei servizi fissi alla generazione in esecuzione…",
  "log.creaGenerazione": "Creazione della nuova generazione (senza avvio)…",
  "log.collegaFissi": "Collegamento dei servizi fissi alla nuova generazione…",
  "log.avvioGenerazione": "Avvio della nuova generazione…",
  "log.attesaGenerazione": "Attesa che la nuova generazione sia pronta…",
  "log.avvioFallito": "Avvio non riuscito: rimozione della generazione incompleta.",
  "log.spostamento": "Spostamento del traffico sulla nuova generazione…",
  "log.rimozioneExFissi": (p: { servizi: string; progetto: string }) =>
    `Rimozione di ${p.servizi} dal progetto "${p.progetto}": non è più fisso…`,
  "log.drenaggio": (p: { secondi: number }) => `Attesa di ${p.secondi}s perché le richieste in corso terminino…`,
  "log.completato": "Rilascio completato senza interruzione del servizio.",
  "log.rimozionePrecedente": (p: { progetto: string }) =>
    `Rimozione della versione precedente (progetto "${p.progetto}")…`,

  // Operazioni
  "log.annullata": (p: { motivo: string }) => `Operazione annullata: ${p.motivo}`,
  "log.fallita": (p: { motivo: string }) => `Operazione fallita: ${p.motivo}`,
  "log.avvioServizi": "Avvio dei servizi…",
  "log.avviato": "Stack avviato.",
  "log.arrestoServizi": "Arresto dei servizi…",
  "log.riavvioServizi": "Riavvio dei servizi…",
  "log.scaricamento": "Scaricamento delle immagini…",
  "log.nessunDettaglio": "nessun dettaglio",
  "log.creaRete": (p: { rete: string }) => `Creazione della rete "${p.rete}", dichiarata dal compose…`,
  "log.operazioneInCorso": (p: { stack: string }) =>
    `un'operazione è già in corso su "${p.stack}": attendi che finisca.`,
  "log.verifica": "Verifica della configurazione…",
  "log.rimozioneGenerazione": (p: { generazione: string }) =>
    `Rimozione della generazione "${p.generazione}", che la ricreazione sostituisce…`,
  "log.arrestato": "Stack arrestato. La configurazione resta salvata.",
  "log.arresto": (p: { stack: string }) => `Arresto di "${p.stack}"…`,
  "log.copiaVolume": (p: { da: string; a: string }) => `Copia del volume ${p.da} in ${p.a}…`,
  "log.vecchioFermo": (p: { stack: string }) => `"${p.stack}" è fermo e conserva il nome: riavvialo da qui se serve.`,
  "log.rinominato": (p: { da: string; a: string }) => `Stack rinominato da "${p.da}" a "${p.a}".`,
  "log.volumiPrecedenti": (p: { volumi: string }) =>
    `I volumi precedenti restano sull'host: ${p.volumi}. Eliminali quando hai verificato i dati.`,
  "log.rimozioneApplicazioni": (p: { progetto: string }) =>
    `Rimozione delle applicazioni dal progetto "${p.progetto}", i fissi restano…`,
  "log.portaOccupata": (p: { porta: number; da: string; libera: number | null }) =>
    `la porta ${p.porta} è occupata da ${p.da}` + (p.libera === null ? "" : ` (libera: ${p.libera})`),
  "log.nomeOccupato": (p: { nome: string; servizio: string; stato: string; progetto: string | null }) =>
    `"${p.nome}" (servizio ${p.servizio}) è già usato da un container ${p.stato} ` +
    (p.progetto === null ? "avviato fuori da Compose" : `del progetto Compose "${p.progetto}"`),

  "log.processoHost": "un processo dell'host esterno a Docker",
  "log.tagMancante": "tag mancante",
  "log.tagNonValido": "tag non valido",
  "log.utenteSconosciuto": "utente sconosciuto",
  "log.passwordErrata": "password errata",
  "log.utenteDisattivato": "utente disattivato",

  // Log del server, per chi lo gestisce
  "server.emailNonInviata": "email di avviso non inviata",
  "server.valutazioneAvvisi": "valutazione degli avvisi fallita",
  "server.avvisoEvento": "avviso dell'evento non gestito",
  "server.statisticheAssenti": "statistiche del container non disponibili",
  "server.dopoGiro": "elaborazione dopo il giro fallita",
  "server.giroFallito": "giro di campionamento fallito",
  "server.dopoEvento": "elaborazione dopo l'evento fallita",
  "server.eventoNonGestito": "evento del container non gestito",
  "server.streamCaduto": "stream degli eventi caduto",
  "server.riassunto": "riassunto delle metriche",
  "server.potatura": "potatura delle metriche",

  "server.ripristinato":
    "Database ripristinato. Portman si sta riavviando: ricarica la pagina fra qualche secondo " +
    "e accedi con le credenziali contenute nel backup.",
  "server.conservaToken": "Conserva questo token: non sarà più mostrato.",
  "server.chiaveLunghezza": (p: { attesi: number; ricevuti: number }) =>
    `la chiave deve essere di ${p.attesi} byte, ricevuti ${p.ricevuti}`,
  "server.cifratoFormato": "cifrato malformato: atteso il formato <versione>.<nonce>.<dati>",
  "server.cifraturaVersione": (p: { versione: string }) => `versione di cifratura non supportata: ${p.versione}`,
  "server.decifrare": "impossibile decifrare: chiave errata o dati alterati",
  "server.cifratoNonce": "cifrato malformato: nonce di lunghezza errata",

  // Messaggi delle revisioni create da Portman
  "revisione.descrizioneImport": (p: { progetto: string }) => `importato dal progetto Compose "${p.progetto}"`,
  "revisione.descrizioneProxy": "Reverse proxy per il rilascio senza interruzione, installato da Portman.",
  "revisione.creazione": "creazione dello stack",
  "revisione.copia": (p: { stack: string; revisione: number | null }) => `copia di ${p.stack} (rev ${p.revisione})`,
  "revisione.ritorno": (p: { numero: number }) => `ritorno alla revisione ${p.numero}`,
  "revisione.importazione": (p: { progetto: string }) => `importazione da container esistenti (progetto "${p.progetto}")`,
  "revisione.porteRimosse": "rimosse le porte host per il rilascio senza interruzione",
  "revisione.proxy": "installazione di Nginx Proxy Manager",
  "revisione.tag": (p: { tag: string }) => `aggiornamento del tag a ${p.tag}`,
  "revisione.webhook": (p: { tag: string }) => `rilascio automatico ${p.tag}`,
  "log.ripristino": (p: { numero: number }) => `Ripristino della revisione ${p.numero}…`,
  "log.ritentaRete": (p: { dettaglio: string; tentativo: number; totale: number; secondi: number }) =>
    `La rete o il registry hanno esitato (${p.dettaglio}). Tentativo ${p.tentativo} di ` +
    `${p.totale} fra ${p.secondi} s…`,
  "log.pullFallito": (p: { dettaglio: string }) =>
    `Scaricamento non riuscito (${p.dettaglio}). Si procede con le immagini già presenti ` +
    "sull'host: se una di esse mancasse, l'avvio si fermerà subito dopo con un errore esplicito.",
};
